import * as React from 'react';

function CircleCheckmarkIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 20 21" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.99 20.25c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm5.158-12.518a.667.667 0 10-.982-.9l-5.488 5.985-2.757-2.757a.667.667 0 00-.943.943l3.25 3.25.492.492.47-.513 5.958-6.5z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default CircleCheckmarkIcon;
